export default __webpack_public_path__ + "static/media/fantasquesansmono-regular-webfont.120ad852.ttf";